import { useEffect } from "react";

import { Theme, useMediaQuery } from "@material-ui/core";
import { useLocation } from "react-router-dom";

export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  const isMobileWidth = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  useEffect(() => {
    if (isMobileWidth) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [isMobileWidth, pathname]);

  return null;
};
